import { changeView } from '../../actions/view';
import { AccountSelectErrorView } from './AccountSelectErrorView';
import { EActiveView } from '../../..';
import { connect } from 'react-redux';
import { authenticateByToken, registerOrAuthorizeByToken } from '../../actions/phoneAuth';
export function mapStateToProps(state) {
  return {
    email: state.phoneAuth.authenticateByToken.account
  };
}
export function mapDispatchToProps(dispatch) {
  return {
    retry: function retry(email) {
      if (email) {
        dispatch(authenticateByToken({
          email: email
        }));
      } else {
        dispatch(registerOrAuthorizeByToken());
      }
      dispatch(changeView(EActiveView.AccountSelect));
    },
    backToList: function backToList() {
      dispatch(changeView(EActiveView.AccountSelect));
    }
  };
}
export var AccountSelectErrorViewContainer = connect(mapStateToProps, mapDispatchToProps)(AccountSelectErrorView);